import { render, staticRenderFns } from "./overseasRegister.vue?vue&type=template&id=5ed0db46&scoped=true&"
import script from "./overseasRegister.vue?vue&type=script&lang=js&"
export * from "./overseasRegister.vue?vue&type=script&lang=js&"
import style0 from "./overseasRegister.vue?vue&type=style&index=0&id=5ed0db46&scoped=true&lang=less&"
import style1 from "./overseasRegister.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed0db46",
  null
  
)

export default component.exports